import { CREATE_VENDOR_LINK_API, CreteVendorLinkError } from '../../constants';

export const createVendorLink = async ({
    vendorID,
    linkType,
    linkText,
    linkUrl
}) => {
    try {
        const user = JSON.parse(localStorage.getItem("user"));
        const response = await fetch(CREATE_VENDOR_LINK_API, {
            method: 'POST',
            headers: new Headers({
                'x-access-token': user.accessToken,
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify({
                vendorid: vendorID,
                type: linkType,
                text: linkText,
                url: linkUrl
            })
        });
        if (!response.ok) throw CreteVendorLinkError;
        const responseJson = await response.json();
        return responseJson;
    } catch (error) {
        throw CreteVendorLinkError;
    }
};